import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ContentBlockWithVideo from '@legacy-vfuk/core-content-block-with-video';
import { FC } from 'react';
import ContentfulRichText from '@uk-source-web/contentful-rich-text';

import SWSectionFiftyFiftyBanner from '../SWSectionFiftyFiftyBanner';
import { Container, WrapItem, Wrapper, WrapText } from './SWContentBlockWithVideo.styles';
import { SWContentBlockWithVideoGroupProps, SWContentBlockWithVideoProps } from './SWContentBlockWithVideo.types';
import Heading from '@legacy-vfuk/core-heading';

const SWContentBlockWithVideo: FC<SWContentBlockWithVideoGroupProps> = ({
  id,
  __typename,
  contentBody,
  contentPosition,
  items,
  videoPosition,
  isPropositionVideo,
  isVerticalLayout,
  backgroundColor,
  title,
  banners,
  ...props
}: SWContentBlockWithVideoGroupProps) => {
  const renderContent = () => {
    if (items && items.length > 0) {
      return items?.map(
        ({
          id,
          __typename,
          name,
          headingLevel,
          contentBody,
          contentPosition,
          videoPosition,
          backgroundColor: cardBackgroundColor,
          ...item
        }: SWContentBlockWithVideoProps) => (
          <WrapItem
            key={`${__typename}-${id}`}
            position={videoPosition}
            textAlign={contentPosition}
            cardBackgroundColor={cardBackgroundColor}
            backgroundColor={backgroundColor}
          >
            <ContentBlockWithVideo
              key={`${__typename}-${id}`}
              heading={{
                ...(headingLevel && { level: headingLevel }),
                text: name,
              }}
              content={{
                bodyText: contentBody ? documentToReactComponents(JSON.parse(contentBody.raw)) : '',
                contentPosition: contentPosition || 'left',
              }}
              {...{ videoPosition }}
              {...item}
              appearance="primary"
            />
          </WrapItem>
        )
      );
    } else if (!items && props.videoId) {
      return (
        <WrapItem
          key={`${__typename}-${id}`}
          position={videoPosition}
          textAlign={contentPosition}
          isVerticalLayout={isVerticalLayout}
          isPropositionVideo={isPropositionVideo}
          backgroundColor={backgroundColor}
        >
          <ContentBlockWithVideo
            key={`${__typename}-${id}`}
            content={{
              bodyText: contentBody ? documentToReactComponents(JSON.parse(contentBody.raw)) : '',
              contentPosition: contentPosition || 'left',
            }}
            {...{ videoPosition }}
            {...props}
          />
        </WrapItem>
      );
    } else if (!items && !props.videoId && contentBody) {
      return (
        <WrapText>
          <ContentfulRichText document={JSON.parse(contentBody.raw)} />
        </WrapText>
      );
    } else {
      return '';
    }
  };
  return (
    <Container backgroundColor={backgroundColor}>
      {title && (
        <Heading level={2} size={4} justify="center" id="content-block-with-video-heading-title" weight={3}>
          {title}
        </Heading>
      )}
      <Wrapper
        {...(!items && { position: videoPosition, isPropositionVideo, isVerticalLayout })}
        backgroundColor={backgroundColor}
        contentPosition={contentPosition}
        bottomPadding={title && '40px'}
      >
        {renderContent()}
        {banners && banners.map(banner => <SWSectionFiftyFiftyBanner key={banner.id} {...banner} />)}
      </Wrapper>
    </Container>
  );
};

export default SWContentBlockWithVideo;
